// documents store inner constants

export const ACT_LOADBALANCE = 'loadBalance';
export const ACT_LOADCOUNTERS = 'loadCounters';
export const ACT_SETFINDSTRING = 'setFindString';

export const GET_COUNTERS = 'countersGet';
export const GET_BALANCE = 'balanceGet';
export const GET_FINDSTRING = 'findStringGet';

export const MUT_ADDCOUNTERS = 'addCounters';
export const MUT_ADDBALANCE = 'addBalance';
export const MUT_SETFINDSTRING = 'addFindString';
